import * as React from "react";
import ReactSpeedometer from "react-d3-speedometer";

const BACGaugeChart = ({ value }) => {
  return (
    <div style={{ 
      width: "100%", 
      height: "250px", 
      maxWidth: "320px", 
      margin: "0 auto",
      padding: "20px",
      boxSizing: "border-box",
      overflow: "hidden",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }}>
      <div style={{ width: "280px", height: "200px", margin: "0 auto" }}>
        <ReactSpeedometer
          fluidWidth={false}
          minValue={0}
          maxValue={0.4}
          value={value}
          needleColor="#fddc6e"
          startColor="#025DC7"
          endColor="#f1646c"
          segments={8}
          ringWidth={20}
          currentValueText=""
          textColor="#333"
          labelFontSize="clamp(6px, 1vw, 10px)"
          segmentValueFormatter={(val) => (val === 0.4 ? val + "+" : val)}
          width={280}
          height={200}
        />
      </div>
    </div>
  );
};

export default BACGaugeChart;
